import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

/**
 * useTelemetry — Phase 3d.
 * Fire-and-forget event ingest for the 4 new hubs (calc-hub, care-planning,
 * digital-twin, diet-optimizer, weight-fluid). Silent on failure so it
 * never impacts UX. Deduplicates back-to-back identical events.
 */
export function useTelemetry(hub, eventType = "open", specialty = null, meta = null) {
  const lastRef = useRef("");
  useEffect(() => {
    if (!hub || !eventType) return;
    const key = `${hub}:${eventType}:${specialty || ""}`;
    if (key === lastRef.current) return;
    lastRef.current = key;
    api.post("/telemetry/event", {
      hub, event_type: eventType, specialty, meta: meta || undefined,
    }).catch(() => { /* silent */ });
  }, [hub, eventType, specialty]);
}

/**
 * fireEvent — imperative form for one-off event pushes (button clicks,
 * explicit "refresh" actions). Same silent-on-failure guarantee.
 */
export function fireTelemetryEvent(hub, eventType, specialty = null, meta = null) {
  if (!hub || !eventType) return;
  api.post("/telemetry/event", {
    hub, event_type: eventType, specialty, meta: meta || undefined,
  }).catch(() => { /* silent */ });
}
